import { 
  collection, 
  addDoc, 
  query, 
  orderBy, 
  onSnapshot, 
  doc, 
  getDoc,
  getDocs,
  updateDoc,
  where,
  increment,
  serverTimestamp 
} from 'firebase/firestore';
import { db } from '../firebase';

export const createChannel = async (name, description, user) => {
  try {
    const docRef = await addDoc(collection(db, 'channels'), {
      name: name.trim(),
      description: description ? description.trim() : '',
      createdBy: user.uid,
      createdAt: serverTimestamp(),
      isDefault: false,
      postsCount: 0
    });
    return docRef.id;
  } catch (error) {
    console.error('Error creating channel:', error);
    throw error;
  }
};

export const subscribeToChannels = (callback) => {
  const q = query(collection(db, 'channels'), orderBy('createdAt', 'asc'));
  
  return onSnapshot(q, (querySnapshot) => {
    const channels = [];
    querySnapshot.forEach((doc) => {
      channels.push({
        id: doc.id,
        ...doc.data()
      });
    });
    callback(channels);
  });
};

export const getChannel = async (channelId) => {
  try {
    const channelRef = doc(db, 'channels', channelId);
    const channelDoc = await getDoc(channelRef);
    
    if (!channelDoc.exists()) {
      throw new Error('Channel not found');
    }
    
    return {
      id: channelDoc.id,
      ...channelDoc.data()
    };
  } catch (error) {
    console.error('Error getting channel:', error);
    throw error;
  }
};

export const createDefaultChannel = async () => {
  try {
    // Check if default channel already exists
    const q = query(collection(db, 'channels'), where('isDefault', '==', true));
    const querySnapshot = await getDocs(q);
    
    if (!querySnapshot.empty) {
      // Default channel already exists, return it
      const doc = querySnapshot.docs[0];
      return {
        id: doc.id,
        ...doc.data()
      };
    }
    
    // Create default channel
    const docRef = await addDoc(collection(db, 'channels'), {
      name: 'General',
      description: 'Welcome to Building HFJ! This is the main discussion channel.',
      createdBy: 'system',
      createdAt: serverTimestamp(),
      isDefault: true,
      postsCount: 0
    });
    
    return {
      id: docRef.id,
      name: 'General',
      description: 'Welcome to Building HFJ! This is the main discussion channel.',
      createdBy: 'system',
      isDefault: true,
      postsCount: 0
    };
  } catch (error) {
    console.error('Error creating default channel:', error);
    throw error;
  }
};

export const incrementChannelPostCount = async (channelId) => {
  try {
    const channelRef = doc(db, 'channels', channelId);
    await updateDoc(channelRef, {
      postsCount: increment(1)
    });
  } catch (error) {
    console.error('Error incrementing channel post count:', error);
    throw error;
  }
};

export const decrementChannelPostCount = async (channelId) => {
  try {
    const channelRef = doc(db, 'channels', channelId);
    await updateDoc(channelRef, {
      postsCount: increment(-1)
    });
  } catch (error) {
    console.error('Error decrementing channel post count:', error);
    throw error;
  }
};